(function ($) {
    "use strict";

    $(function () {
        if ($(".js-pm-gallery-slider").length) {
            new Swiper(".js-pm-gallery-slider", {
                slidesPerView: 1.15,
                spaceBetween: 12,
                speed: 400,
                grabCursor: true,
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    nextEl: ".js-pm-gallery-slider-next",
                    prevEl: ".js-pm-gallery-slider-prev",
                },
                pagination: {
                    el: ".js-pm-gallery-slider-pagination",
                    clickable: true,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2.15,
                        spaceBetween: 12,
                    },
                    768: {
                        slidesPerView: 3.15,
                        spaceBetween: 16,
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 32,
                    },
                },
            });
        }
    });
})(jQuery);
